export enum MouseButtons {
  BrowserBack = 3,
  BrowserForward = 4,
  Left = 0,
  Mid = 1,
  Right = 2,
}
